.container {
  position: fixed;
  bottom: calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) + var(--space-6));
  left: var(--space-4);
  right: var(--space-4);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  z-index: 1000;
  pointer-events: none;
}

/* Variant C — elevated navy pill: neutral surface, ice-blue text, strong shadow.
   Appears in place (no entry animation); the exiting class fades it out. */
.toast {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-width: 240px;
  max-width: 360px;
  padding: 11px 22px;
  /* Client screens hold the studio's look; admin falls back to its own palette. */
  background: var(--bg-card, var(--color-bg-elevated));
  color: var(--text-primary, var(--color-accent-text));
  border: 1px solid var(--border-soft, rgba(240, 234, 214, 0.12));
  border-radius: var(--radius-full);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-align: center;
  pointer-events: auto;
}

/* Long messages wrap to at most two lines instead of clipping. */
.message {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
}

/* Leading icon carries the only semantic color; the pill surface stays neutral. */
.icon {
  flex: none;
}

.iconSuccess {
  color: var(--accent, var(--color-success));
}

.iconError {
  color: var(--danger, var(--color-error));
}

.iconInfo {
  color: var(--accent, var(--color-accent-text));
}

.exiting {
  opacity: 0;
  transition: opacity 200ms ease;
}
